export default __webpack_public_path__ + "static/media/small Blue.7b5cf4e5.png";